import { render } from "./app-logo.vue?vue&type=template&id=4026b781"
import script from "./app-logo.vue?vue&type=script&lang=js"
export * from "./app-logo.vue?vue&type=script&lang=js"

import "./app-logo.vue?vue&type=style&index=0&id=4026b781&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__